"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var react_1 = __importStar(require("react"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var AddBox_1 = __importDefault(require("@mui/icons-material/AddBox"));
var react_router_dom_1 = require("react-router-dom");
var EditOutlined_1 = __importDefault(require("@mui/icons-material/EditOutlined"));
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var AxiosClient_1 = require("../../utils/AxiosClient");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var Products = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var _b = (0, react_1.useState)(false), openDelete = _b[0], setOpenDelete = _b[1];
    var _c = (0, react_1.useState)(""), pid = _c[0], setPid = _c[1];
    var _d = (0, react_1.useState)({
        ProductID: "",
        ProductName: "",
        ProductPrice: 0,
        quantity: 0,
        available: true,
        ProductDesc: "",
        ProductOwner: "",
        createdAt: "",
        updatedAt: "",
        pro_images: [
            {
                ImageID: "",
                ImagePath: "",
                ImageType: "",
                ProductID: "",
                createdAt: "",
                updatedAt: "",
            },
        ],
    }), preview = _d[0], setPreview = _d[1];
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () {
        setOpen(false);
        setOpenDelete(false);
    };
    document.title = "Products Management || !SHOP";
    var theme = (0, styles_1.useTheme)();
    var token = js_cookie_1.default.get("token");
    var fullScreen = (0, useMediaQuery_1.default)(theme.breakpoints.down("sm"));
    var _e = (0, react_1.useState)({
        status: 0,
        message: "",
        products: [],
    }), products = _e[0], setProducts = _e[1];
    var _f = (0, react_1.useState)(false), isDeleting = _f[0], setIsDeleting = _f[1];
    var handleDeleteProduct = function (ProductID) {
        setIsDeleting(true);
        setPid(ProductID);
        setOpenDelete(true);
    };
    var confirmDelete = function () {
        react_hot_toast_1.default.loading("Hang on while we are processing your request...");
        AxiosClient_1.AxiosClient.delete("/products/delete/".concat(pid), {
            headers: { Authorization: "Bearer ".concat(token) },
        })
            .then(function (response) {
            react_hot_toast_1.default.remove();
            if (response.data.statusCode == 201) {
                setIsDeleting(false);
                react_hot_toast_1.default.success("Your Product is deleted!");
                setOpenDelete(false);
                window.location.reload();
            }
            else {
                setIsDeleting(false);
                react_hot_toast_1.default.error("Something went wrong...");
                setOpenDelete(false);
            }
        })
            .catch(function (error) {
            react_hot_toast_1.default.remove();
            console.log(error);
            react_hot_toast_1.default.error("Something went wrong, try again.");
        });
    };
    var _g = (0, react_1.useState)(true), fetching = _g[0], setFetching = _g[1];
    (0, react_1.useEffect)(function () {
        AxiosClient_1.AxiosClient.get("/products/allSellerCollection", {
            headers: { Authorization: "Bearer ".concat(token) },
        })
            .then(function (response) {
            if (response.data.status == 200) {
                setProducts(response.data);
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () { return setFetching(false); });
    }, []);
    var handlePreviewClick = function (prev) {
        setPreview(prev);
        handleOpen();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(material_1.Box, { sx: { display: "flex" } },
            react_1.default.createElement(material_1.Box, { component: "main", sx: { flexGrow: 1, pt: 10, pl: 2 } },
                react_1.default.createElement(material_1.Button, { variant: "contained", component: react_router_dom_1.Link, to: "/add-product", color: "primary", startIcon: react_1.default.createElement(AddBox_1.default, null) }, "Add new"),
                react_1.default.createElement(material_1.Container, { maxWidth: "xl" },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, style: {
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: "10px",
                        } },
                        fetching && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(CircularProgress_1.default, null),
                            " ",
                            react_1.default.createElement(material_1.Typography, { paragraph: true, sx: { fontWeight: 700 } }, "Fetching Products ..."),
                            " ")),
                        products
                            ? products.products.map(function (product, indx) {
                                return (react_1.default.createElement(material_1.Grid, { key: indx, item: true, xs: 12, sm: 6, md: 5, lg: 3 },
                                    react_1.default.createElement(material_1.Card, { style: {
                                            boxShadow: "0 0 10px 0 rgba(0,0,0,.4)",
                                            borderRadius: 10,
                                        } },
                                        react_1.default.createElement(material_1.CardMedia, { component: "img", onClick: function () { return handlePreviewClick(product); }, alt: product.ProductName, sx: { height: "250px", objectFit: "cover" }, image: product.pro_images[0].ImagePath }),
                                        react_1.default.createElement(material_1.CardContent, null,
                                            react_1.default.createElement(material_1.Typography, { gutterBottom: true, variant: "h5", component: "h2" }, product.ProductName),
                                            react_1.default.createElement(material_1.Typography, { variant: "body2", color: "text.secondary", component: "p", gutterBottom: true },
                                                product.ProductDesc.substring(0, 90),
                                                " ..."),
                                            react_1.default.createElement(material_1.Typography, { gutterBottom: true, variant: "h5", component: "h5", sx: { fontWeight: 600 } },
                                                "RWF ",
                                                product.ProductPrice)),
                                        react_1.default.createElement(material_1.CardActions, { sx: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                            } },
                                            react_1.default.createElement(material_1.Button, { size: "small", color: "primary", onClick: function () {
                                                    return navigate("/edit-product", { state: product });
                                                }, startIcon: react_1.default.createElement(EditOutlined_1.default, null), variant: "contained" }, "Edit"),
                                            react_1.default.createElement(material_1.Button, { size: "small", color: "error", disabled: isDeleting, onClick: function () {
                                                    return handleDeleteProduct(product.ProductID);
                                                }, startIcon: react_1.default.createElement(DeleteForever_1.default, null), variant: "outlined" }, "Delete")))));
                            })
                            : "No Products Found"),
                    react_1.default.createElement(material_1.Dialog, { fullScreen: fullScreen, open: open, onClose: handleClose, "aria-labelledby": "product-modal-title" },
                        react_1.default.createElement(material_1.Box, null,
                            react_1.default.createElement(material_1.DialogTitle, { id: "product-modal-title-success" }, preview === null || preview === void 0 ? void 0 : preview.ProductName),
                            react_1.default.createElement(material_1.DialogContent, null,
                                react_1.default.createElement("img", { src: preview === null || preview === void 0 ? void 0 : preview.pro_images[0].ImagePath, alt: preview === null || preview === void 0 ? void 0 : preview.ProductName, style: {
                                        width: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                        borderRadius: "10px",
                                    } }),
                                react_1.default.createElement(material_1.Typography, { variant: "h4", style: { fontWeight: "bold" }, gutterBottom: true },
                                    "RWF ", preview === null || preview === void 0 ? void 0 :
                                    preview.ProductPrice),
                                react_1.default.createElement(material_1.DialogContentText, { mb: 2 }, preview === null || preview === void 0 ? void 0 :
                                    preview.ProductName,
                                    " ",
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement(material_1.Typography, { paragraph: true }, preview === null || preview === void 0 ? void 0 : preview.ProductDesc)),
                                react_1.default.createElement(material_1.ImageList, { variant: "quilted", cols: 4, rowHeight: 150 }, preview.pro_images.map(function (image, i) { return (react_1.default.createElement(material_1.ImageListItem, { key: i },
                                    react_1.default.createElement("img", { style: { borderRadius: "5px" }, src: image.ImagePath, alt: preview === null || preview === void 0 ? void 0 : preview.ProductName, id: image.ImageID, loading: "lazy" }))); }))),
                            react_1.default.createElement(material_1.DialogActions, null,
                                react_1.default.createElement(material_1.Button, { variant: "outlined", onClick: handleClose }, "Close")))),
                    react_1.default.createElement(material_1.Dialog, { fullScreen: fullScreen, open: openDelete, onClose: handleClose, "aria-labelledby": "product-modal-delete-title" },
                        react_1.default.createElement(material_1.Box, null,
                            react_1.default.createElement(material_1.DialogTitle, { id: "product-modal-delete-title-success" }, "Confirm to delete"),
                            react_1.default.createElement(material_1.DialogContent, null,
                                react_1.default.createElement(material_1.DialogContentText, { mb: 2 },
                                    react_1.default.createElement(material_1.Typography, { paragraph: true }, "Once you confirmed to delete this product, you can not restore it."))),
                            react_1.default.createElement(material_1.DialogActions, null,
                                react_1.default.createElement(material_1.Button, { variant: "outlined", onClick: handleClose }, "Close"),
                                react_1.default.createElement(material_1.Button, { variant: "contained", color: "error", onClick: confirmDelete }, "Yes, i want to delete"))))))),
        react_1.default.createElement(react_hot_toast_1.Toaster, null)));
};
exports.default = Products;
